import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { Form, Col, Modal } from "react-bootstrap";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { reAuth } from "../app/modules/Auth/_redux/authCrud";
import { errorMessage } from "../app/util/Helpers";
import cogoToast from 'cogo-toast';
import {actions} from "../app/modules/Auth/_redux/authRedux"
import { toAbsoluteUrl } from "../_metronic/_helpers";

const SessionExpireModal = _ => {

    const auth = useSelector(state => state.auth, shallowEqual);
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
  
    /* Redux Disatch */
    const dispatch = useDispatch();

    const handleSubmit = e =>  {
      e.preventDefault();
      e.stopPropagation();
      const form = e.currentTarget;
      if (form.checkValidity() === true) {
        setIsLoading(true);
        const {email, password} = Object.fromEntries((new FormData(form)).entries());
        reAuth(email, password, auth?.user?.id).then(({ data }) => {
          const currDate = new Date();
          auth.session.active = true;
          currDate.setMinutes(currDate.getMinutes() + auth.session.validity);
          auth.session.expire = currDate.getTime();
          dispatch(actions.updateSession(data.access_token, auth.session));
        })
        .catch(error => {
          cogoToast.error(errorMessage(error));
          if (error?.response?.status === 403){
            setTimeout(_ => dispatch(actions.logout()), 500);
          }
        })
        .finally(_ => {
          setIsLoading(false);
          setValidated(false);
        });
      }
      setValidated(true);
    }

    return (
        <Modal
            show={!auth.session.active || auth.session.expire < (new Date()).getTime()}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            keyboard={false}
            onExited={_ => setValidated(false)}
          >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            disabled={isLoading}
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Code/Warning-1-circle.svg")}
                    />
                </span>
                Enter Your Login Credentials
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-12 pt-5">
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="auth-email">
                    <Form.Label >Email</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      name="email"
                      pattern="[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})"
                    />
                    <Form.Control.Feedback  type="invalid">Kindly provide a valid email</Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} md="12" controlId="auth-password">
                    <Form.Label >Password</Form.Label>
                    <Form.Control 
                      type="password" 
                      required
                      name="password"
                      minLength="8"
                      maxLength="50"
                    />
                    <Form.Control.Feedback type="invalid">
                      Kindly provide your password
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="submit"
                    className="btn btn-lg btn-primary btn-elevate px-5 mr-5"

                >
                    Submit
                  <div className={`spinner-border spinner-border-sm ml-4 text-white ${isLoading ? "" : "d-none"}`} role="status">
                      <span className="sr-only">Loading...</span>
                  </div>
                </button>
            </Modal.Footer>
              </Form>
          </Modal>
    
            );

}

export default SessionExpireModal;